module.exports = __webpack_public_path__ + "static/media/easy-customise.80fba52b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/easy-customise.jpg
// module id = 917
// module chunks = 0